export default __webpack_public_path__ + "static/media/loader.9a6d9701.png";